<template>
  <div>
    <div v-if="type" class="header">
      <div class="headDiv">
        <img style="height: 62rem" src="../assets/img/header/logo.png" />
      </div>
      <div
        @click="link(index + 1)"
        class="headerItem"
        v-for="(item, index) in headArray"
        :key="index"
        @mouseenter="getIndex(index)"
      >
        <el-popover
          placement="bottom"
          :open-delay="0"
          :close-delay="0"
          width="260rem"
          trigger="hover"
          :visible-arrow="false"
        >
          <div
            :class="[
              'options',
              nowIndex == 0
                ? 'options1'
                : nowIndex == 1
                ? 'options2'
                : nowIndex == 2
                ? 'options3'
                : 'options4'
            ]"
          >
            <a @click="link(index + 1)" class="option" :href="item.id1"
              ><el-dropdown-item>
                {{ item.option1 }}
              </el-dropdown-item></a
            >
            <a @click="link(index + 1)" class="option" :href="item.id2"
              ><el-dropdown-item>
                {{ item.option2 }}
              </el-dropdown-item></a
            >
            <a @click="link(index + 1)" class="option" :href="item.id3"
              ><el-dropdown-item>
                {{ item.option3 }}
              </el-dropdown-item></a
            >
          </div>
          <span
            slot="reference"
            :class="[
              'el-dropdown-link',
              activeIndex == index + 1 ? 'titleColor' : ''
            ]"
          >
            {{ item.title }}
          </span>
        </el-popover>
        <!-- <el-dropdown @command="link(index + 1)" trigger="hover">
        <span
          :class="[
            'el-dropdown-link',
            activeIndex == index + 1 ? 'titleColor' : '',
          ]"
        >
          {{ item.title }}
        </span>
        <el-dropdown-menu slot="dropdown">
          <a class="option" :href="item.id1"
            ><el-dropdown-item>
              {{ item.option1 }}
            </el-dropdown-item></a
          >
          <a class="option" :href="item.id2"
            ><el-dropdown-item>
              {{ item.option2 }}
            </el-dropdown-item></a
          >
          <a class="option" :href="item.id3"
            ><el-dropdown-item>
              {{ item.option3 }}
            </el-dropdown-item></a
          >
        </el-dropdown-menu>
      </el-dropdown> -->
      </div>
      <!-- <div @click="link(2)" class="headerItem">
      <el-dropdown @command="link(2)">
        <span :class="['el-dropdown-link',activeIndex==2?'titleColor':'']"> Business Introduction </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item><a href="#about">Intelligent Match</a></el-dropdown-item>
          <el-dropdown-item><a href="#about">Technical Output</a></el-dropdown-item>
          <el-dropdown-item><a href="#about">Enabling Scene</a></el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div @click="link(3)" class="headerItem">
      <el-dropdown @command="link(3)">
        <span :class="['el-dropdown-link',activeIndex==3?'titleColor':'']"> About Credpay </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item><a href="#about">Company Profile</a></el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div @click="link(4)" class="headerItem">
      <el-dropdown @command="link(4)">
        <span :class="['el-dropdown-link',activeIndex==4?'titleColor':'']"> Join Us </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item><a href="#about">Company Culture</a></el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div> -->
    </div>
    <div v-else id="header2">
      <div class="header2">
        <div @click="link(1)">
          <img class="imgLogo" src="../../logo.png" alt="" />
        </div>
        <div class="trigger" @click="trigger = !trigger">
          <div>
            <div v-show="!trigger">
              <svg
                width="28px"
                height="28px"
                viewBox="0 0 28 28"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <title>icon-menu</title>
                <g
                  id="英文web"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g
                    id="响应式nav"
                    transform="translate(-318.000000, -19.000000)"
                  >
                    <g
                      id="icon-menu"
                      transform="translate(318.000000, 19.000000)"
                    >
                      <rect id="矩形" x="0" y="0" width="28" height="28"></rect>
                      <g id="列表模式_块" fill-rule="nonzero">
                        <rect
                          id="矩形"
                          fill="#000000"
                          opacity="0"
                          x="0"
                          y="0"
                          width="28"
                          height="28"
                        ></rect>
                        <path
                          d="M2.625,3.5 L25.375,3.5 L25.375,8.75 L2.625,8.75 L2.625,3.5 Z M2.625,11.375 L25.375,11.375 L25.375,16.625 L2.625,16.625 L2.625,11.375 Z M2.625,19.25 L25.375,19.25 L25.375,24.5 L2.625,24.5 L2.625,19.25 Z"
                          id="形状"
                          fill="#1478F0"
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          </div>
          <div>
            <div v-show="trigger">
              <svg
                width="28px"
                height="29px"
                viewBox="0 0 28 29"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                style=""
              >
                <title>icon-cross</title>
                <g
                  id="英文web"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g
                    id="响应式nav-menuList"
                    transform="translate(-318.000000, -18.000000)"
                  >
                    <g
                      id="icon-cross"
                      transform="translate(318.000000, 18.813185)"
                    >
                      <rect
                        id="矩形"
                        x="0"
                        y="0.186814511"
                        width="28"
                        height="28"
                      ></rect>
                      <g id="列表模式_块" fill-rule="nonzero">
                        <rect
                          id="矩形"
                          fill="#000000"
                          opacity="0"
                          x="0"
                          y="0"
                          width="28"
                          height="28"
                        ></rect>
                        <path
                          d="M19.5563492,5 L23.0918831,8.53553391 L17.081,14.546 L23.0918831,20.5563492 L19.5563492,24.0918831 L13.546,18.081 L7.53553391,24.0918831 L4,20.5563492 L10.011,14.546 L4,8.53553391 L7.53553391,5 L13.546,11.011 L19.5563492,5 Z"
                          id="形状结合"
                          fill="#1478F0"
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div v-if="trigger" id="myoptions" class="optionstwo">
        <div
          :class="['option2', activeIndex == index + 1 ? 'titleColor' : '']"
          v-for="(item, index) in headArray"
          :key="index"
          @click="link(index + 1)"
        >
          {{ item.title }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      logo: require("../assets/img/header/logo.png"),
      activeIndex: "1",
      headArray: [
        {
          title: "Home",
          option1: "Business Introduction",
          id1: "#Business-Introduction",
          option2: "Business Model",
          id2: "#Business-Model",
          option3: "Cooperative Institutions",
          id3: "#Cooperative-Institutions"
        },
        {
          title: "Business Introduction",
          option1: "Intelligent Match",
          id1: "#Intelligent-Match",
          option2: "Technical Output",
          id2: "#Technical-Output",
          option3: "Enabling Scene",
          id3: "#Enabling-Scene"
        },
        {
          title: "Product introduction",
          option1: "Product introduction",
          id1: "#Product introduction"
        },
        {
          title: "About Credpay",
          option1: "Company Profile",
          id1: "#company-profile"
        },
        {
          title: "Join Us",
          option1: "Company Culture",
          id1: "#company-culture"
        }
      ],
      nowIndex: 0,
      type: 1,
      trigger: false //true为打开，false为关闭
    };
  },
  created() {
    document.addEventListener("click", e => {
      let box = document.getElementById("header2");
      if (!box.contains(e.target)) {
        this.trigger = false;
      }
    });
    this.fontSizeAuto();
    window.addEventListener("resize", this.fontSizeAuto);
    // this.activeIndex = window.localStorage.getItem("activeIndex")
    //   ? window.localStorage.getItem("activeIndex")
    //   : "1";
    this.activeIndex = "1";
    this.$router.replace("/");
  },
  methods: {
    fontSizeAuto() {
      let viewportWidth = document.documentElement.clientWidth;
      if (viewportWidth < 1200) {
        this.type = 0;
      } else {
        this.trigger = false;
        this.type = 1;
      }
    },
    getIndex(index) {
      this.nowIndex = index;
    },
    link(val) {
      window.localStorage.setItem("activeIndex", val);
      this.activeIndex = val;
      if (val == 1) {
        if (this.$route.name != "Home") {
          this.$router.replace("/");
        }
      } else if (val == 2) {
        if (this.$route.name != "Business-Introduction") {
          this.$router.replace("/BusinessIntroduction");
        }
      } else if (val == 3) {
        if (this.$route.name != "Product-Introduction") {
          this.$router.replace("/ProductIntroduction");
        }
      } else if (val == 4) {
        if (this.$route.name != "Credpay") {
          this.$router.replace("/Credpay");
        }
      } else if (val == 5) {
        if (this.$route.name != "Join") {
          this.$router.replace("/join");
        }
      }
    }
  }
};
</script>

<style scoped>
.header {
  font-family: PingFangSC;
  position: fixed;
  top: 0;
  width: 100%;
  height: 92rem;
  display: flex;
  align-items: center;
  /* justify-content: center; */
  background-color: #ffffff;
  z-index: 99;
}
.headerItem {
  margin-left: 35rem;
}
.headDiv {
  margin-left: 285rem;
  margin-right: 76rem;
  width: 118rem;
  height: 92rem;
  display: flex;
  align-items: center;
}
.el-dropdown-link {
  border: none;
  font-size: 18rem;
  cursor: pointer;
  font-weight: 500;
}
.titleColor {
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12rem;
}
.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14rem;
  margin-bottom: 20rem;
}
.option {
  width: 260rem;
  height: 60rem;
  color: #212934;
}
.options {
  width: 260rem;
  opacity: 0.9;
  position: fixed;
  top: 92rem;
  left: 0;
  background: rgb(231, 232, 235);
}
.options1 {
  left: 504.5rem;
}
.options2 {
  left: 592rem;
}
.options3 {
  left: 811rem;
}
.options4 {
  left: 969.5rem;
}

.header2 {
  position: fixed;
  top: 0;
  width: 100%;
  height: 92rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  z-index: 99;
}
.logo {
  cursor: pointer;
  position: fixed;
  height: 60rem;
  top: 0;
  left: 42%;
  margin-top: 16rem;
}
.trigger {
  height: 28rem;
  width: 28rem;
  cursor: pointer;
  position: fixed;
  top: 30rem;
  right: 14rem;
}
.optionstwo {
  position: fixed;
  top: 92rem;
  height: 285rem;
  width: 100%;
  padding: 20rem;
  background-color: #ffffff;
  cursor: pointer;
  z-index: 99;
}
.option2 {
  border-top: 1px solid #dbdbdb;
  height: 60rem;
  font-size: 18rem;
  line-height: 60rem;
}
/* /deep/.el-dropdown-menu {
  background-color: rgb(231, 232, 235);
}
/deep/.el-popper[x-placement^="bottom"] .popper__arrow::after {
  top: 1rem;
  margin-left: -6rem;
  border-top-width: 0;
  border-bottom-color: rgba(231, 232, 235, 0);
}
/deep/.el-popper .popper__arrow,
.el-popper .popper__arrow::after {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: none;
}
/deep/.el-popper[x-placement^="bottom"] {
  margin-top: 35rem;
  width: 260rem;
}
/deep/.el-dropdown-menu__item {
  list-style: none;
  line-height: 36rem;
  padding: 0 20rem;
  margin: 0;
  font-size: 18rem;
  color: #606266;
  cursor: pointer;
  outline: 0;
} */

.imgLogo {
  width: 125rem;
  height: 60rem;
  background-color: #ffffff;
  /* margin-top: 16rem; */
}
.trigger div i {
  width: 28px;
  height: 28px;
  font-size: 28px;
  color: #409eff;
}
</style>

// WEBPACK FOOTER // // src/components/Header.vue



// WEBPACK FOOTER //
// src/components/Header.vue